import React from 'react';
import {callAction} from 'client/framework';
import appStore from 'client/AppStore';
import schoolAdministrationStore from 'client/SchoolAdministration/SchoolAdministrationStore';
import schoolAdministrationActions from '../SchoolAdministrationActions';

import '../school-administration.scss';

export default class School extends React.Component {
  UNSAFE_componentWillMount() {
    if (appStore.routerProps.params.schoolId !== schoolAdministrationStore.getActiveSchoolId()) {
      callAction(
        schoolAdministrationActions.SET_ACTIVE_SCHOOL_ID,
        appStore.routerProps.params.schoolId
      );
    }
  }

  render() {
    return (
      <div className='school-dashboard'>
        {this.props.children && React.cloneElement(this.props.children, {})}
      </div>
    );
  }
}
